import { useEffect, useRef, useState } from 'react';
import { getMatchShowResult } from 'service/base';

const MatchResult = ({ match }) => {
  const [scrollIndex, setScrollIndex] = useState(0);
  const scrollRef = useRef(null);
  const rowHeight = 40; // Adjust based on actual row height
  const visibleRows = 7;

  useEffect(() => {
    const interval = setInterval(() => {
      setScrollIndex((prevIndex) => {
        const maxIndex = Math.max(0, match.results.length - 1);
        return (prevIndex + 1) % (maxIndex + 1);
      });
    }, 2000); // Change scroll every 3 seconds

    return () => clearInterval(interval);
  }, [match.results.length]);

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollIndex * rowHeight; // Adjust 40 based on row height
    }
  }, [scrollIndex]);

  return (
    <div className="shadow-md rounded-lg overflow-hidden xl:mb-6 mx-2 xl:mx-8 border border-solid border-[#36A638]">
      {/* Header */}
      <div className="bg-[#36A638] text-[#FFF] text-center px-4 py-2 text-sm font-bold">
        Kết quả trận đấu của: {match.title}
      </div>
      <div className="flex xl:flex-row flex-col space-x-4 pt-2 lg:px-4 xl:gap-0 gap-4 bg-gray-100">
        {/* Team Scores */}
        <div className="flex items-center flex-col justify-around xl:justify-start xl:w-1/4 xl:px-0 px-4 border-gray-200 gap-2">
          <div className="flex w-full items-center">
            <div className="flex w-1/2 max-w-[50%] min-w-0 items-center justify-end gap-1 pr-1 xl:mb-4 xl:w-full xl:max-w-none xl:justify-between">
              <div className="flex min-w-0 flex-1 items-center overflow-hidden">
                <img
                  src={match.homeTeam.logo}
                  alt={match.homeTeam.name}
                  className="h-10 w-10 shrink-0"
                />
                <span className="ml-1 min-w-0 truncate text-xs font-bold">
                  {match.homeTeam.name}
                </span>
              </div>
              <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-[#36A638] font-bold text-white">
                {match.homeTeam.score}
              </div>
            </div>
            <div className="flex w-1/2 max-w-[50%] min-w-0 flex-row-reverse items-center justify-end gap-1 pl-1 xl:w-full xl:max-w-none xl:flex-row xl:justify-between">
              <div className="flex min-w-0 flex-1 flex-row-reverse items-center overflow-hidden xl:flex-row">
                <img
                  src={match.awayTeam.logo}
                  alt={match.awayTeam.name}
                  className="h-10 w-10 shrink-0"
                />
                <span className="mr-1 min-w-0 truncate text-xs font-bold">
                  {match.awayTeam.name}
                </span>
              </div>
              <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-[#36A638] font-bold text-white">
                {match.awayTeam.score}
              </div>
            </div>
          </div>

          <div className="w-full h-full flex justify-center items-center flex-row gap-2">
            <p className="text-[#333] font-roboto text-sm sm:text-base md:text-lg font-bold leading-normal">
              Số người dự đoán đúng
            </p>
            <p className="text-[#36A638] text-center font-roboto text-md sm:text-lg md:text-3xl font-bold leading-normal">
              {match.results.length}
            </p>
          </div>
        </div>

        {/* Results Table */}
        <div
          className="overflow-y-auto xl:w-3/4 mx-auto"
          ref={scrollRef}
          style={{ maxHeight: `${rowHeight * visibleRows}px` }}
        >
          <table className="table-auto w-full text-left text-sm">
            <thead className="bg-gray-100 text-gray-700 sticky top-0">
              <tr>
                <th className="px-1 xl:px-4 py-2 w-1/12 text-center hidden lg:table-cell">STT</th>
                <th className="px-1 xl:px-4 py-2 w-2/12 text-center">TK</th>
                <th className="px-1 xl:px-4 py-2 w-4/12 text-center">Họ và Tên</th>
                <th className="px-1 xl:px-4 py-2 w-2/12 text-center">VIP</th>
                {/* <th className="px-1 xl:px-4 py-2 w-2/12 text-center">Điểm Thưởng</th> */}
              </tr>
            </thead>
            <tbody>
              {match.results.map((result, index) => (
                <tr key={index} className={`${index % 2 === 0 ? 'bg-gray-50' : 'bg-white'}`}>
                  <td className="px-1 xl:px-4 py-2  text-center hidden lg:table-cell">
                    {index + 1}
                  </td>
                  <td className="px-1 xl:px-4 py-2  text-center">{result.account}</td>
                  <td className="px-1 xl:px-4 py-2  text-center">{result.name}</td>
                  <td className="px-1 xl:px-4 py-2  text-center">{result.vipLevel}</td>
                  {/* <td className="px-1 xl:px-4 py-2  text-center">{result.point}</td> */}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

const MatchResultsList = () => {
  const [matches, setMatches] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getMatchShowResult();
        console.log('API response:', response);
        if (response.code === 0 && Array.isArray(response.data)) {
          setMatches(response.data);
          console.log('load match result success ' + response.data.length);
          setError(null);
        } else {
          setMatches([]);
          setError('CÙNG CM88 THAM GIA DỰ ĐOÁN TỶ SỐ VÀ NHẬN THƯỞNG HẤP DẪN MỖI NGÀY!');
        }
      } catch (err) {
        setMatches([]);
        setError('Không thể tải kết quả trận đấu');
        console.error('Fetch error:', err);
      }
    };
    fetchData();
  }, []);

  return (
    <div className="xl:w-7/10 md:w-9/10 sm:w-9/10 w-9/10 mx-auto bg-[#F2FBF3]  border border-solid border-[#36A638] pb-10 rounded-xl">
      <h2 className="text-2xl font-bold text-center rounded-t-xl py-2 text-white bg-[#36A638] mb-8">
        KẾT QUẢ TRẬN ĐẤU
      </h2>
      {error && <div className="text-red-500 text-center mb-4">{error}</div>}
      <div className="mx-auto flex flex-col gap-2">
        {matches.map(
          (match, index) => match?.results?.length > 0 && <MatchResult key={index} match={match} />
        )}
      </div>
    </div>
  );
};

export default MatchResultsList;
